import angular from 'angular';

import CardComponent from './card.component';

const CardModule = angular.module('control-room.commons.basic.components.card', []).component('crCard', CardComponent);

export default CardModule;
